import * as ScrollMagic from "scrollmagic";
import { TweenMax, TimelineMax } from "gsap";
import { ScrollMagicPluginGsap } from "scrollmagic-plugin-gsap";

ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax);

if ($('#trigger').length) {

	var controller = new ScrollMagic.Controller();
	var controller2 = new ScrollMagic.Controller();
	var marginTop1 = 'translate3d(0px, 0px, 0px)',
		marginBottom1 = 'translate3d(-5px, 0px, 0px)',
		marginTop2 = 'translate3d(0px, 0px, 0px)',
		marginBottom2 = 'translate3d(0px, 0px, 0px)',
		durationVal1 = 600,
		durationVal2 = 450,
		ww = $(window).width();

	if (ww < 768) {
		let marginVal = 0;
		let durationVal = 200;
	}

	var sceneTop = new ScrollMagic.Scene({triggerElement: "#trigger", duration: durationVal1})
		// animate color and top border in relation to scroll position
		.setTween(".js-parallaxSpecializations .js-parallaxTop", {transform: marginTop1}) // the tween durtion can be omitted and defaults to 1
		// .addIndicators({name: "1 (duration: 1000)"}) // add indicators (requires plugin)
		.addTo(controller);

	var sceneBottom = new ScrollMagic.Scene({triggerElement: "#trigger", duration: durationVal1})
		// animate color and top border in relation to scroll position
		.setTween(".js-parallaxSpecializations .js-parallaxBottom", {transform: marginBottom1}) // the tween durtion can be omitted and defaults to 1
		// .addIndicators({name: "2 (duration: 1000)"}) // add indicators (requires plugin)
		.addTo(controller);

	var sceneTop2 = new ScrollMagic.Scene({triggerElement: "#trigger-2", duration: durationVal2})
		// animate color and top border in relation to scroll position
		.setTween(".js-parallaxFeedback .js-parallaxTop", {transform: marginTop2}) // the tween durtion can be omitted and defaults to 1
		// .addIndicators({name: "1 (duration: 1000)"}) // add indicators (requires plugin)
		.addTo(controller2);

	var sceneBottom2 = new ScrollMagic.Scene({triggerElement: "#trigger-2", duration: durationVal2})
		// animate color and top border in relation to scroll position
		.setTween(".js-parallaxFeedback  .js-parallaxBottom", {transform: marginBottom2}) // the tween durtion can be omitted and defaults to 1
		// .addIndicators({name: "2 (duration: 1000)"}) // add indicators (requires plugin)
		.addTo(controller2);


}
